import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ETAType } from '../eta-type.model';

@Component({
  selector: 'app-delivery-timeline',
  templateUrl: './delivery-timeline.component.html',
  styleUrls: ['./delivery-timeline.component.scss']
})
export class DeliveryTimelineComponent {

  @Input() plannedArrival: string;
  @Input() eta: string;
  @Input() etaType?: ETAType;
  @Input() arrival: string;
  @Input() departure: string;
  @Input() timezoneOffset: string;
  @Input() arrivalExclamation: boolean;
  @Input() departureExclamation: boolean;

  @Output()
  onShowEtaDetails = new EventEmitter<void>();

  showEtaDetails() {
    this.onShowEtaDetails.emit();
  }
}
